import React from 'react';

import { Icon } from '../../icon';
import { IconProps } from '../../icon/types';

export const SuccessIcon = (props: IconProps) => (
  <Icon
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM17.7204 8.22648C17.3651 7.90915 16.8083 7.92752 16.4767 8.26752L10.8922 13.9932L8.45271 11.9922C8.0837 11.6895 7.52816 11.7304 7.21187 12.0835C6.89558 12.4367 6.93831 12.9683 7.30732 13.2709L10.3873 15.7973C10.7453 16.0909 11.2816 16.0623 11.6033 15.7325L17.7633 9.41669C18.0949 9.07669 18.0757 8.54382 17.7204 8.22648Z"
      fill="currentColor"
    />
  </Icon>
);
